(function () {
  var STORAGE_KEY = 'tsq:recently-viewed';
  var MAX_ITEMS = 12;

  function readHistory() {
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY);
      var list = raw ? JSON.parse(raw) : [];
      return Array.isArray(list) ? list : [];
    } catch (error) {
      return [];
    }
  }

  function writeHistory(list) {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    } catch (error) {
      // localStorage unavailable (private mode, quota, etc.) - fail silently.
    }
  }

  function recordCurrentProduct() {
    var dataEl = document.querySelector('[data-recently-viewed-current]');
    if (!dataEl) return null;
    var current;
    try {
      current = JSON.parse(dataEl.textContent);
    } catch (error) {
      return null;
    }
    if (!current || !current.id) return current;

    var history = readHistory().filter(function (item) {
      return item.id !== current.id;
    });
    history.unshift(current);
    history = history.slice(0, MAX_ITEMS);
    writeHistory(history);
    return current;
  }

  var currentProduct = recordCurrentProduct();

  class RecentlyViewedProducts extends HTMLElement {
    constructor() {
      super();
      this.list = this.querySelector('.recently-viewed__list');
      this.render();
    }

    render() {
      var history = readHistory().filter(function (item) {
        return !currentProduct || item.id !== currentProduct.id;
      });

      if (!history.length) {
        this.hidden = true;
        return;
      }

      this.list.innerHTML = history
        .slice(0, 6)
        .map(function (item) {
          var price = typeof item.price === 'number' ? formatMoney(item.price) : '';
          var image = item.image || '';
          return (
            '<li class="recently-viewed__item">' +
            '<a href="' + item.url + '" class="recently-viewed__media">' +
            (image ? '<img src="' + image + '" alt="" loading="lazy" width="120" height="120">' : '') +
            '</a>' +
            '<a href="' + item.url + '" class="recently-viewed__title">' + escapeHtml(item.title) + '</a>' +
            (price ? '<span class="recently-viewed__price">' + price + '</span>' : '') +
            '</li>'
          );
        })
        .join('');

      this.hidden = false;
    }
  }

  function formatMoney(cents) {
    var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'AED';
    try {
      return (cents / 100).toLocaleString(undefined, { style: 'currency', currency: currency });
    } catch (error) {
      return (cents / 100).toFixed(2);
    }
  }

  function escapeHtml(str) {
    var div = document.createElement('div');
    div.textContent = str || '';
    return div.innerHTML;
  }

  if (!customElements.get('recently-viewed-products')) {
    customElements.define('recently-viewed-products', RecentlyViewedProducts);
  }
})();
